import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {CustomerConfigService} from "../../../_shared/customer-config-service";
import {
    ContactConfigurationDto,
    ContactConfigurationService,
    CustomRoleDto
} from "../../../_services/configuration-services";
import {FormUtils} from "../../../_shared/form-utils";
import {Location} from '@angular/common';
import {NotificationsService} from '../../../_shared/notifications.service';

@Component({
    selector: 'app-contact-management',
    templateUrl: './contact-management.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactManagementComponent implements OnInit {

    contactConfigForm: UntypedFormGroup;

    constructor(public readonly customerConfigService: CustomerConfigService,
                private readonly location: Location,
                private readonly notificationService: NotificationsService,
                private readonly contactConfigurationService: ContactConfigurationService) {

        this.contactConfigForm = new UntypedFormGroup({
            email: new UntypedFormControl(null, [Validators.required, FormUtils.emailValidator]),
            customRoles: new FormControl<CustomRoleDto[] | null>(null),
            cguFR: new UntypedFormControl(null, [Validators.required, Validators.maxLength(2500)]),
            cguDE: new UntypedFormControl(null, Validators.maxLength(2500)),
            cguIT: new UntypedFormControl(null, Validators.maxLength(2500)),
            cguEN: new UntypedFormControl(null, Validators.maxLength(2500)),
        });
    }

    ngOnInit(): void {
        this.fetchConfiguration();
    }

    saveConfiguration(): void {
        const contactConfiguration = new ContactConfigurationDto({
            customRoles: this.customRoles.value ?? [],
            cguFR: this.cguFR.value,
            cguDE: this.cguDE.value,
            cguIT: this.cguIT.value,
            cguEN: this.cguEN.value,
            email: this.email.value
        })

        this.contactConfigurationService.saveContactConfiguration(contactConfiguration).pipe().subscribe(() => {
            this.notificationService.success({ title: 'communicationChannel.contact.notification.configurationSavedSuccess'});
            this.contactConfigForm.markAsPristine();
        });
    }

    back(): void {
        this.location.back();
    }

    private fetchConfiguration(): void {
        this.contactConfigurationService.getContactConfiguration().pipe().subscribe(contactConfiguration => {
            this.email.setValue(contactConfiguration.email);

            this.cguFR.setValue(contactConfiguration.cguFR);
            this.cguDE.setValue(contactConfiguration.cguDE);
            this.cguIT.setValue(contactConfiguration.cguIT);
            this.cguEN.setValue(contactConfiguration.cguEN);

            this.customRoles.setValue(contactConfiguration.customRoles ?? []);
        });
    }

    get email(): UntypedFormControl {
        return this.contactConfigForm.get('email') as UntypedFormControl;
    }

    get cguFR(): UntypedFormControl {
        return this.contactConfigForm.get('cguFR') as UntypedFormControl;
    }

    get cguDE(): UntypedFormControl {
        return this.contactConfigForm.get('cguDE') as UntypedFormControl;
    }

    get cguIT(): UntypedFormControl {
        return this.contactConfigForm.get('cguIT') as UntypedFormControl;
    }

    get cguEN(): UntypedFormControl {
        return this.contactConfigForm.get('cguEN') as UntypedFormControl;
    }

    get customRoles(): FormControl<CustomRoleDto[] | null> {
        return this.contactConfigForm.get('customRoles') as FormControl<CustomRoleDto[] | null>;
    }

}
